import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../../lib/I18n';
import Smartcard from '../../../records/customer/Smartcard';

import Icon from '../../general/Icon';

function KeyGoNotAvailable ({ smartcard }) {
    const message = smartcard.productAvailability === 0 ?
        t('account.smartcard.keygo.cardFull') :
        t('account.smartcard.keygo.cardBusy');
    return (
        <p className="alert-danger">
            <Icon icon="error" className="otrl-inline" /> <span className='text-weight--normal'>{ t('account.smartcard.keygo.notAvailable') }</span> { message }
        </p>
    );
}

KeyGoNotAvailable.propTypes = {
    smartcard: PropTypes.instanceOf(Smartcard).isRequired
};

export default KeyGoNotAvailable;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/KeyGoNotAvailable.js